var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "dashboard-widget notification",
      class: _vm.status_class,
      attrs: { title: _vm.tooltip },
    },
    [
      _vm.status_icon
        ? _c("i", {
            staticClass: "dashboard-status-icon",
            class: _vm.status_icon,
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "columns is-mobile" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", {
            staticClass: "dashbaord-status-value",
            domProps: { innerHTML: _vm._s(_vm.text) },
          }),
          _vm._v(" "),
          _c("small", { domProps: { innerHTML: _vm._s(_vm.text_subtitle) } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _c("div", {
            staticClass: "dashbaord-status-value",
            domProps: { innerHTML: _vm._s(_vm.text2) },
          }),
          _vm._v(" "),
          _c("small", { domProps: { innerHTML: _vm._s(_vm.text2_subtitle) } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }